import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';

import { ConfigService } from '../config/config.service';
import { DownloadFormat } from '../download/download.service';
import { UserInfo } from '../user/user.service';

@Injectable()
export class ReportsService {

    constructor(private configService: ConfigService, private http: HttpClient) { }

    // #region Get Available Reports Method

        GetAvailableReports(AuthToken: string, CurrentRole: string) {
            return this.http.get<ReportInfo[]>(this.configService.hostAddress + `Api/Services/Report/GetAvailableReports?AuthToken=${AuthToken || ''}&Role=${CurrentRole || ''}`);
        }

    // #endregion

}

// #region Custom Classes

    // #region Report Info Class

        export class ReportInfo {
            AllowedRoles: string[];
            CanSetDistrict?: boolean;
            CanSetSchool?: boolean;
            CanChooseStudent?: boolean;
            Description?: string;
            ReportID?: number;
            StudentID?: string;
            SortOrder: number;
            Title: string;
            ReportFileFormat: DownloadFormat;
        }

    // #endregion

// #endregion


// WEBPACK FOOTER //
// ./src/services/reports/reports.service.ts